import { trans } from "~/providers/lang";
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function OurCommodityPage() {
	useSeo({
		title: trans("skelet.title.ourcommodity"),
		canonical: "/nase-nabidka",
	});

	return <div className="body-background">
		<div className="ourcommodity-page page-content top-shadow">
			<h1 className="other-page-title">
				{trans('services.title')}
			</h1>
			<div className="row">
				<div className="col-md-12">
					<h2>
						{trans('services.preTitle')}
					</h2>
					<p>
						{trans('services.line1')}
					</p>
					<p>
						{trans('services.line2')}
					</p>
					<p dangerouslySetInnerHTML={{ __html: trans('services.line3') }} />
					<p dangerouslySetInnerHTML={{ __html: trans('services.line4') }} />
					<p dangerouslySetInnerHTML={{ __html: trans('services.line5') }} />
					<p style={{ textAlign: "right" }} dangerouslySetInnerHTML={{ __html: trans('services.owner') }} />
					<h2>
						{trans('services.offers')}
					</h2>
					<h3>
						{trans('services.borrow')}
					</h3>
					<ul className="square">
						<li>
							{trans('services.borrow1')}
						</li>
						<li>
							{trans('services.borrow2')}
						</li>
						<li>
							{trans('services.borrow3')}
						</li>
						<li>
							{trans('services.borrow4')}
						</li>
						<li>
							{trans('services.borrow5')}
						</li>
						<li>
							{trans('services.borrow6')}
						</li>
						<li>
							{trans('services.borrow7')}
						</li>
						<li>
							{trans('services.borrow8')}
						</li>
						<li>
							{trans('services.borrow9')}
						</li>
					</ul>
					<h3>
						{trans('services.sell')}
					</h3>
					<ul className="square">
						<li>
							{trans('services.sell1')}
						</li>
						<li>
							{trans('services.sell2')}
						</li>
						<li>
							{trans('services.sell3')}
						</li>
						<li>
							{trans('services.sell4')}
						</li>
						<li>
							{trans('services.sell5')}
						</li>
						<li>
							{trans('services.sell6')}
						</li>
						<li>
							{trans('services.sell7')}
						</li>
					</ul>
					<h3>
						{trans('services.video')}
					</h3>
					<h3>
						{trans('services.limo')}
					</h3>
					<h3>
						{trans('services.weddingArch')}
					</h3>
					<h3>
						{trans('services.chairCovers')}
					</h3>
				</div>
			</div>
		</div>
	</div>;
}
